import type { ObjectValues } from '@repo/common';

export const ViewType = {
  FULL_PAGE: 'full-page',
  IFRAME: 'iframe',
} as const;

export type ViewTypeValues = ObjectValues<typeof ViewType>;
